import dd4kids_img from '../../../assets/images/dd4kids.jpg';
import styled from 'styled-components';

export const Wrapper = styled.div`
padding-top: 3rem;
margin-bottom: 3rem;
width: 100%;
max-width: 1640px;

  .hero-img {
    width: 100%;
    max-width: 800px;
    border-radius: var(--mid-border-radius);
    margin-bottom: 2rem;
  }

  .info-list {
    list-style: none;
    padding: 0;
    margin: 0 0 2rem 0;
    font-size: 1.1rem;
  }
  .info-list li {
    padding: 0.3rem 0;
  }
  .info-list li strong {
    display: inline-block;
    min-width: 140px;
  }
`

export const Dd4Kids = () => {

  return (
    <Wrapper>
      <div className='lr-padded-container center-text'>
        <h1 style={{marginBottom: '25px'}}>D&D 4 Kids</h1>
        <hr style={{maxWidth: '200px', marginInline: 'auto'}}/>
      </div>

      <div className='lr-padded-container center-text'>
        <img src={dd4kids_img} alt='Dungeons and Dragons for Kids and Teens' className='hero-img' />
      </div>

      <div className='lr-padded-container center-text'>
        <h2>Presented by the Young Adventurers League</h2>
        <p>Running in the St Kilda Library all day Saturday and Sunday</p>
      </div>

      <div className='lr-padded-container center-text'>
        <ul className='info-list'>
          <li><strong>Session Times:</strong> 10:30am, 1:00pm and 3pm</li>
          <li><strong>Duration:</strong> 90 mins</li>
          <li><strong>Age Groups:</strong> 8-12 and 13-15</li>
        </ul>
        <a href="https://aftergame.app/events/74aa19fa-71b3-4b6c-a741-d4349f14a07f" className='btn-pink' style={{margin: '0 auto'}}>Book a Place Here</a>
        <p style={{marginTop: '0.5rem', fontSize: 'var(--smallText)'}}>Or just walk up to Ro at the admin desk and sign up</p>
      </div>
    </Wrapper>
  )
}
